module.exports = __webpack_public_path__ + "static/media/AntonioSchiratti.9a8928a5.jpg";